<template>
  <div class="machineHealth">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0 text-center">
        <b-col
          v-for="(item, key) in machineHealthData"
          :key="key"
          cols="12"
          sm="12"
          md="6"
          lg="6"
          xl="4"
          class="px-3 m-0 mb-2"
        >
          <b-table
            :items="item.table.items"
            :fields="item.table.fields"
            :no-border-collapse="noCollapse"
            responsive
            class="machineHealth-table-detail"
          >
            <template #thead-top="">
              <b-tr>
                <b-th
                  colspan="5"
                  style="
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                  "
                >
                  <span>{{ item.name }}</span>
                </b-th>
              </b-tr>
            </template>
          </b-table>
          <!-- <div>
          </div> -->
        </b-col>
      </b-row>
    </b-container>
    <!-- <div
      v-for="(item, key) in machineHealthData"
      :key="key"
      class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 row px-3 m-0 mb-2"
    >
      <b-card
        class="w-100"
        border-variant="secondary"
        :header="item.name"
        header-border-variant="secondary"
        align="center"
      >
        <b-card-text class="overflow-auto">
          <b-table
            :items="item.table.items"
            :fields="item.table.fields"
            class="machStatus-table-detail machStatus-table-detail-select"
          ></b-table>
        </b-card-text>
      </b-card>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "machineHealth",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      machineHealthData: "machineHealth/get_machineHealthData",
    }),
  },
};
</script>

<style lang="scss">
.machineHealth-table-detail th,
.machineHealth-table-detail td {
  height: 3rem;
  min-width: 65px;
  padding: 0.7rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  background-color: #ffffff;
  vertical-align: middle!important;
}
.machineHealth-table-detail th:first-child,
.machineHealth-table-detail td:first-child {
  border-left: 1px solid;
}
.machineHealth-table-detail {
  margin-bottom: 0px;
}
.machineHealth-table-detail thead th {
  font-size: 1rem;
  color: #000000;
  background-color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/machineHealth.vue